import MainContent from '../../components/mainContent/MainContent';
import { PacienteProbableContent } from './components/PacienteProbableContent';

export default function PacienteProbableSearch() {

    return (
        <MainContent
            component={<PacienteProbableContent />}
            titulo='Pre Paciente'
            noBackground
            tableMaxWidth
        />
    );

};